import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherIssuedMarkVoucherAsUnUsed_DetailsPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherIssuedMarkVoucherAsUnUsed_DetailsPage($input: VoucherIssuedForCampaignMarkVoucherAsUnUsedInput!) {
		voucherIssuedForCampaignMarkVoucherAsUnUsed(input: $input) {
			userErrors
			voucherIssuedForCampaign {
				hotelID
				voucherCode
				userECReceiptID
				usedReservationID
				useableStartDt
				cinStart
				cinEnd
				guestName
				guestEmail
				guestPostalCode
				guestAddress
				guestTel
				sendingMethod
				resourceAvailablePrice {
					currencyType
					amount
				}
				createdAt
				createdDt
				usedAt
			}
		}
	}
`);
